/**
 * @file: useOrderTags.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { OrderTag } from '@euler/model';
import { useServiceFactory } from '@euler/services/factory';
import { onErrorReturn } from '@euler/utils';
import { useAutoClearAsyncResource } from '@euler/utils/hooks';
import { useCallback } from 'react';

export const useOrderTags = () => {
  const { inventoryService } = useServiceFactory();
  const query = useCallback(async () => {
    return await inventoryService
      .getPredefinedOrderTags()
      .catch(onErrorReturn([] as OrderTag[]));
  }, [inventoryService]);
  return useAutoClearAsyncResource(query, 'predefined-order-tags');
};
